import React from 'react'

export const LineItemContext = React.createContext()
export const QuantityContext = React.createContext()

export const CartContext = React.createContext()
